import { Zap, Instagram, Youtube, Facebook, Linkedin, Mail, Phone, MapPin } from "lucide-react";
// Zap kept for potential icon use; logo now uses the brand image.
import { BRAND } from "@/data/content";

const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="relative border-t border-white/10 bg-black">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center">
            <img src="/assets/brandify-logo.png" alt="Brandify" className="h-10 w-auto" />
          </div>
          <p className="mt-5 text-sm text-zinc-400 leading-relaxed max-w-sm">
            {BRAND.tagline} Brand activation & experiential marketing that turns real-world moments into viral social media content.
          </p>
          <div className="mt-6 flex gap-3">
            {[
              { icon: Instagram, href: BRAND.socials.instagram, id: "instagram" },
              { icon: Youtube, href: BRAND.socials.youtube, id: "youtube" },
              { icon: Facebook, href: BRAND.socials.facebook, id: "facebook" },
              { icon: Linkedin, href: BRAND.socials.linkedin, id: "linkedin" },
            ].map(({ icon: Icon, href, id }) => (
              <a
                key={id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`footer-social-${id}`}
                className="w-10 h-10 rounded-full glass flex items-center justify-center text-zinc-400 hover:text-white hover:border-indigo-400/50 transition-colors duration-300"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">Contact</h4>
          <ul className="mt-5 space-y-4 text-sm text-zinc-400">
            <li>
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="inline-flex items-center gap-3 hover:text-white transition-colors">
                <Mail className="w-4 h-4 text-indigo-400" /> {BRAND.email}
              </a>
            </li>
            <li>
              <a href={`tel:${BRAND.phone.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="inline-flex items-center gap-3 hover:text-white transition-colors">
                <Phone className="w-4 h-4 text-indigo-400" /> {BRAND.phone}
              </a>
            </li>
            <li>
              <a href={BRAND.whatsappLink} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="inline-flex items-center gap-3 hover:text-white transition-colors">
                <Phone className="w-4 h-4 text-purple-400" /> WhatsApp: {BRAND.whatsapp}
              </a>
            </li>
            <li className="inline-flex items-center gap-3">
              <MapPin className="w-4 h-4 text-indigo-400" /> {BRAND.address}
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white">Explore</h4>
          <ul className="mt-5 space-y-3 text-sm text-zinc-400">
            {[
              ["About", "#about"], ["Services", "#services"], ["Pricing", "#pricing"],
              ["Campaigns", "#portfolio"], ["Social Content", "#social"],
            ].map(([label, href]) => (
              <li key={href}><a href={href} className="hover:text-white transition-colors">{label}</a></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-zinc-500">© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
        <p className="text-xs text-zinc-600">Real People. Real Reactions. Real Content. Real Results.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
